import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {fadeIn} from '../../styles/keyframes/keyframes';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 34rem;
  background: ${p => `url(${p.url}) no-repeat center center`};
  background-size: cover;
  animation: 0.5s ${fadeIn} ease-in;
  transition: all 1s ease;
  ${media.small`
    height: 30rem;
  `};
`;

export const Dots = styled.div`
  position: absolute;
  bottom: 0;
  height: 4rem;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Dot = styled.div`
  background-color: ${p => p.theme.primaryColor};
  width: 1.4rem;
  height: 1.4rem;
  cursor: pointer;
  border-radius: 50%;
  margin: 0 1rem;
  opacity: 0.7;
`;

export const Container = styled.div`
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/Images.style.js